import { Box, Stack } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { DashboardButton } from "./NavigationBarButtons/DashboardButton";
import { StationsButton } from "./NavigationBarButtons/StationsButton";
import { AlertsButton } from "./NavigationBarButtons/AlertsButton";
import { MapButton } from "./NavigationBarButtons/MapButton";
import { AnalyticsButton } from "./NavigationBarButtons/AnalyticsButton";
import { debounce } from "@mui/material";

export default function NavigationBar({...params}) {

    let navigate = useNavigate()

    let startingDashboardButtonState = 'default'
    let startingStationsButtonState = 'default'
    let startingAnalyticsButtonState = 'default'
    let startingMapButtonState = 'default'
    let startingAlertsButtonState = 'default'

    let url = window.location.pathname
    if (url === '/') startingDashboardButtonState = 'active'
    else if (url === '/stationspage') startingStationsButtonState = 'active'
    else if (url === '/analyticspage') startingAnalyticsButtonState = 'active'
    else if (url === '/mappage') startingMapButtonState = 'active'
    else if (url === '/alertspage') startingAlertsButtonState = 'active'

    const [dashboardButtonState, setDashboardButtonState] = useState(startingDashboardButtonState)
    const [stationsButtonState, setStationsButtonState] = useState(startingStationsButtonState)
    const [analyticsButtonState, setAnalyticsButtonState] = useState(startingAnalyticsButtonState)
    const [mapButtonState, setMapButtonState] = useState(startingMapButtonState)
    const [alertsButtonState, setAlertsButtonState] = useState(startingAlertsButtonState)

    const setAllButtonsToDefault = () => {
        setDashboardButtonState('default')
        setStationsButtonState('default')
        setAnalyticsButtonState('default')
        setMapButtonState('default')
        setAlertsButtonState('default')
    }

    const handleDashboardButtonClick = (event) => {
        event.preventDefault()
        if (url === '/' && dashboardButtonState === 'hover') return
        setAllButtonsToDefault()
        setDashboardButtonState('active')
        if (url !== '/') navigate('/')
    };

    const handleStationsButtonClick = (event) => {
        event.preventDefault()
        if (url === '/stationspage' && stationsButtonState === 'hover') return
        setAllButtonsToDefault()
        setStationsButtonState('active')
        if (url !== '/stationspage') navigate('/stationspage')
    };

    const handleAnalyticsButtonClick = (event) => {
        event.preventDefault()
        if (url === '/analyticspage' && analyticsButtonState === 'hover') return
        setAllButtonsToDefault()
        setAnalyticsButtonState('active')
        if (url !== '/analyticspage') navigate('/analyticspage')
    };

    const handleMapButtonClick = (event) => {
        event.preventDefault()
        if (url === '/mappage' && mapButtonState === 'hover') return
        setAllButtonsToDefault()
        setMapButtonState('active')
        if (url !== '/mappage') navigate('/mappage')
    };

    const handleAlertsButtonClick = (event) => {
        event.preventDefault()
        if (url === '/alertspage' && alertsButtonState === 'hover') return
        setAllButtonsToDefault()
        setAlertsButtonState('active')
        if (url !== '/alertspage') navigate('/alertspage')
    };

    let barPositon = 'fixed'
    let barBottom = '0'
    let page = params.page
    if (page === 'EditPage') {
        barPositon = ''
        barBottom = ''
    }

    let boxStyling = {
        position: barPositon,
        bottom: barBottom,
        display: 'flex',
        height: '95px',
        paddingTop: '22px',
        paddingBottom: '22px',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        backgroundColor: 'NavigationBar.background',
    }

    let labelFormatting = {
        fontWeight: 600,
        fontSize: '14px',
        textAlign: 'center',
        verticalAlign: 'middle',
        color: 'primary.main',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '-0.42px',
    }


    const [width, setWidth] = useState(window.innerWidth)
    useEffect(() => {
        const handleResize = debounce(() => setWidth(window.innerWidth), 10)
        window.addEventListener('resize', handleResize);
        return () => {window.removeEventListener('resize', handleResize);}
    }, [])

    let iconSpacing = ''
    if (width > 721) iconSpacing = '50px'
    else if (width > 421 && width < 721) iconSpacing = String(0.133 * width - 45.893) + 'px'
    else iconSpacing = '10px'

    
    return (
        <>
            <Box sx={boxStyling} position={barPositon} bottom={barBottom} width={"100%"} zIndex={10} id={"NavBarBox"}>
                <Stack direction={'row'} spacing={iconSpacing}>
                    <DashboardButton labelFormatting={labelFormatting} dashboardButtonState={dashboardButtonState} setDashboardButtonState={setDashboardButtonState} handleClick={handleDashboardButtonClick}/>
                    <StationsButton labelFormatting={labelFormatting} stationsButtonState={stationsButtonState} setStationsButtonState={setStationsButtonState} handleClick={handleStationsButtonClick}/>
                    <AnalyticsButton labelFormatting={labelFormatting} analyticsButtonState={analyticsButtonState} setAnalyticsButtonState={setAnalyticsButtonState} handleClick={handleAnalyticsButtonClick}/>
                    <MapButton labelFormatting={labelFormatting} mapButtonState={mapButtonState} setMapButtonState={setMapButtonState} handleClick={handleMapButtonClick}/>
                    <AlertsButton labelFormatting={labelFormatting} alertsButtonState={alertsButtonState} setAlertsButtonState={setAlertsButtonState} handleClick={handleAlertsButtonClick}/>
                </Stack>
            </Box>
        </>
    );
}
